import { useEmployeePin } from "./useEmployeePin";
import {
  EMPLOYEE_PERMISSION_PAGES,
  resolvePagePermission,
} from "~~/interface/EmployeePermission";
const ALLOW_PATHS = ["topup/"]

export const usePermission = () => {
  return {
    checkPermissionPage,
  };

  function checkPermissionPage(path) {
    if (!path) return;

    //let path =  useRouter().currentRoute.value.path
    let emp = useEmployeePin().getEmployeeFull();
    if (emp == null) {
      return true;
    }

    //IS ADMIN FOR FULL ACCESS
    if (emp.admin) {
      return true;
    }

    if (ALLOW_PATHS.includes(path)) {
      return true
    }

    const EMP_PAGE = emp.pages_permissions || {};

    if (EMP_PAGE[EMPLOYEE_PERMISSION_PAGES.ALL]) {
      return true;
    }

    const requiredPermission = resolvePagePermission(path);

    // ไม่มีสิทธิ์ไหนคุมหน้านี้ (หน้านอกเมนูหลัก เช่น /select-run-mode) ปล่อยให้เฉพาะคนที่ติ๊ก "ทั้งหมด"
    if (!requiredPermission) {
      return false;
    }

    //If user haven't opened the store yet, display the Dashboard page.
    // หน้าย่อยในแดชบอร์ดมีการ์ดของตัวเองอีกชั้น (hasPermissionPage / isValidDisableSaleDashboard)
    if (requiredPermission == EMPLOYEE_PERMISSION_PAGES.DASHBOARD) {
      return true;
    }

    return EMP_PAGE[requiredPermission] === true;
  }
};
